    import React, { useEffect,useRef,useState  } from "react";
    import { useParams } from "react-router-dom";
    import useEventSSE from "../../hooks/useEventSSE";
    import shapeTop from "../../images/EventLiveScreenImages/shape-top.svg";
    import shapeBottom from "../../images/EventLiveScreenImages/shape-bottom.svg";
    import upNextCelebration from "../../images/EventLiveScreenImages/upnext-celebration-logo.png";
    import whiteStar from "../../images/EventLiveScreenImages/white-star.svg";
    import pinkStar from "../../images/EventLiveScreenImages/pink-star.svg";
    import awardOne from "../../images/EventLiveScreenImages/award-1.svg";
    import awardTwo from "../../images/EventLiveScreenImages/award-2.svg";
    import "./EventLiveScreen.css";

    const EventLiveScreen = () => {
        const { id } = useParams();
        const viewerRef = useRef(null);
        const [showClose, setShowClose] = useState(false);
        const hideTimerRef = useRef(null);
        const data = useEventSSE(id);
        const hasData = (obj) => obj && Object.keys(obj).length > 0;

        const eventInfo = data?.eventInfo;
        const onStage = data?.onStag;
        const next = data?.nextOnStage;
        const awards = data?.breaks;
        const isAwardsEmpty = !awards || Object.keys(awards).length === 0;

        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||(navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1); // iPadOS 13+ desktop UA




        const clearHideTimer = () => {
            if (hideTimerRef.current) {
                clearTimeout(hideTimerRef.current);
                hideTimerRef.current = null;
            }
        };

        // autoHideMs = 0 -> hover ke liye (jab tak mouse zone mein hai, visible rahe)
        // const revealClose = (autoHideMs = 3000) => {
        //     if (isIOS) return;
        //     clearHideTimer();
        //     setShowClose(true);
        //     if (autoHideMs) {
        //         hideTimerRef.current = setTimeout(() => setShowClose(false), autoHideMs);
        //     }
        // };

        const revealClose = (autoHideMs = 3000) => {
            // Native fullscreen active hai to browser ka apna × use hoga
            if (document.fullscreenElement || document.webkitFullscreenElement) return;
            clearHideTimer();
            setShowClose(true);
            if (autoHideMs) {
                hideTimerRef.current = setTimeout(() => setShowClose(false), autoHideMs);
            }
        };

        const hideClose = () => {
            clearHideTimer();
            setShowClose(false);
        };

        useEffect(() => clearHideTimer, []);



        const removeFullscreenClasses = () => {
            viewerRef.current?.classList.remove("active-fullscreen");
            document.body.classList.remove("viewer-fullscreen");
            document.documentElement.classList.remove("viewer-fullscreen");
        };

        const openFullscreen = async () => {
            const viewer = viewerRef.current;
            if (!viewer) return;

            // Always enable the CSS layout first. This also works as a
            // fallback on iPad browsers that do not support element fullscreen.
            viewer.classList.add("active-fullscreen");
            document.body.classList.add("viewer-fullscreen");
            document.documentElement.classList.add("viewer-fullscreen");

            try {
                if (
                    document.fullscreenElement === viewer ||
                    document.webkitFullscreenElement === viewer
                ) {
                    return;
                }

                if (typeof viewer.requestFullscreen === "function") {
                    await viewer.requestFullscreen();
                } else if (typeof viewer.webkitRequestFullscreen === "function") {
                    viewer.webkitRequestFullscreen();
                }
                // Keep CSS fullscreen classes if native fullscreen is unsupported.
            } catch (err) {
                // Do not remove the CSS classes here: keep the fallback layout.
                console.warn(
                    "Native fullscreen unavailable; keeping CSS fullscreen layout.",
                    err
                );
            }
        };

        const closeFullscreen = async () => {
            try {
                if (document.fullscreenElement && document.exitFullscreen) {
                    await document.exitFullscreen();
                } else if (
                    document.webkitFullscreenElement &&
                    document.webkitExitFullscreen
                ) {
                    document.webkitExitFullscreen();
                }
            } catch (err) {
                console.warn("Could not exit native fullscreen:", err);
            } finally {
                removeFullscreenClasses();
                hideClose();
            }
        };

        useEffect(() => {
            if (sessionStorage.getItem("autoFullscreen") === "true") {
                sessionStorage.removeItem("autoFullscreen");
                setTimeout(() => {
                    openFullscreen();
                }, 300);
            }
        }, []);


        useEffect(() => {
            const handleFullscreenChange = () => {
                if (!document.fullscreenElement && !document.webkitFullscreenElement) {
                    removeFullscreenClasses();
                }
                hideClose();
            };

            window.addEventListener("pagehide", removeFullscreenClasses);
            window.addEventListener("popstate", removeFullscreenClasses);
            document.addEventListener("fullscreenchange", handleFullscreenChange);
            document.addEventListener("webkitfullscreenchange", handleFullscreenChange);

            return () => {
                removeFullscreenClasses();
                window.removeEventListener("pagehide", removeFullscreenClasses);
                window.removeEventListener("popstate", removeFullscreenClasses);
                document.removeEventListener("fullscreenchange", handleFullscreenChange);
                document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
            };
        }, []);

        return (
            <section className="upnext-sec" id="viewer" ref={viewerRef}  onPointerDown={(e) => {
                // touch/pen (iPad, TV, tablet): tap par button 3 sec ke liye dikhao
                if (e.pointerType !== "mouse") revealClose(3000);
            }}>
                 <div
                    className="viewer-close-zone"
                    onMouseEnter={() => revealClose(0)}
                    onMouseLeave={hideClose}
                >
                    <button
                        type="button"
                        className={`viewer-close-button${showClose ? " is-visible" : ""}`}
                        onClick={closeFullscreen}
                        tabIndex={showClose ? 0 : -1}
                        aria-label="Exit fullscreen"
                        title="Exit fullscreen"
                    >
                        ×
                    </button>
                </div>
                {/* SHAPES */}
                <span className="shape-element-top">
                    <img src={shapeTop} alt="" />
                </span>
                <span className="shape-element-bottom">
                    <img src={shapeBottom} alt="" />
                </span>

                <div className="upnext-inner-wrapper mb-4">
                    <div className="container-fluid">
                        <div className="up-next-container">

                            {/* HEADER */}
                            <div className="d-flex justify-content-between align-items-end flex-wrap gap-4 mb-4">
                                <div className="logo">
                                    <img src={upNextCelebration} alt="" />
                                </div>
                                <h2>{eventInfo?.event_title || "—"}</h2>
                            </div>
                            <div className="row g-3">
                                {/* ================= UP NEXT ================= */}
                                <div className="col-md-4 col-lg-4 col-xl-4">
                                    <div className="award-box award-box-blue">

                                        <div className="award-box-header">
                                            <img src={whiteStar} alt="" />
                                            <h3>Up Next</h3>
                                            <img src={whiteStar} alt="" />
                                        </div>

                                        {next?.length > 0 ? (

                                            <div className="award-box-stage">
                                                {next.map((item, index) => (
                                                    <div
                                                        key={index}
                                                        className="award-box-content-list"
                                                    >
                                                        <div className="award-box-count">
                                                            <span>#{item.entry}</span> {item.entry_title}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                        ) : (

                                            <div className="award-box-content">
                                                <h4>No upcoming performances</h4>
                                                <p>Please check back soon</p>
                                            </div>

                                        )}

                                    </div>
                                </div>

                                {/* ================= ON STAGE ================= */}
                                <div className="col-md-4 col-lg-4 col-xl-4">
                                    <div className="award-box award-box-yellow">

                                        <div className="award-box-header">
                                            <img src={pinkStar} alt="" />
                                            <h3>On Stage Now</h3>
                                            <img src={pinkStar} alt="" />
                                        </div>

                                        {hasData(onStage) && onStage.type === "routine" ? (
                                            <div className="award-box-stage">
                                                <h2>#{onStage.entry}</h2>
                                                <h3>{onStage.entry_title}</h3>
                                                <p>{onStage?.studio_name || ""}</p>
                                            </div>
                                        ) : hasData(onStage) && onStage.type === "break" ? (

                                            <div className="award-box-content">
                                                <h4>{onStage.title}</h4>
                                                <p>{onStage.message}</p>
                                            </div>

                                        ): (
                                            <div className="award-box-content">
                                                <h4>No Performance Live</h4>
                                                <p>The stage is currently empty</p>
                                            </div>
                                        )}

                                    </div>
                                </div>

                                {/* ================= AWARDS ================= */}
                                <div className="col-md-4 col-lg-4 col-xl-4">
                                    <div className="award-box award-box-pink">


                                        <div className="award-box-header">
                                            <img src={awardOne} alt="" />
                                            <h3>Awards</h3>
                                            <img src={awardTwo} alt="" />
                                        </div>

                                        {isAwardsEmpty ? (
                                            <div className="award-box-content">
                                                <h4>Awards not started</h4>
                                                <p>Details will appear when the event starts</p>
                                            </div>
                                        ) : awards.actsAway > 0 ? (
                                            <div className="award-box-stage color-blue">
                                                <h2>{awards.actsAway}</h2>
                                                <h3>Routines Until <br /> Awards</h3>
                                            </div>
                                        ) : (
                                            <div className="award-box-content">
                                                <h4>Awards Happening Now</h4>
                                                <p>Please stay tuned</p>
                                            </div>
                                        )}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {/* FOOTER */}
                <div className="upnext-footer mt-auto">
                    <div className="upnext-welcome-content">
                        <div className="upnext-welcome-border">
                            WELCOME TO CELEBRATION TALENT COMPETITION!
                            <span> Good Luck to All Performers!</span>
                        </div>
                    </div>
                    <div className="upnext-web">
                        <a href="http://www.celebrationtalent.com/" target="_blank" rel="noreferrer">
                            www.celebrationtalent.com
                        </a>
                    </div>
                </div>
            </section>
        );
    };

    export default EventLiveScreen;